import { MenuItem } from "@mui/material";
import DropDownButton from "components/DropDownButton";
import DateInput from "components/form/input/DateInput";
import { endOfMonth, endOfWeek, endOfYear, formatISO, startOfMonth, startOfWeek, startOfYear } from "date-fns";

export default function SeletoresData({ change }) {
    const setDatasEstaSemana = () => {
        let dateRef = new Date();
        const di = startOfWeek(dateRef, { weekStartsOn: 0 })

        const df = endOfWeek(dateRef, { weekStartsOn: 0 })

        change("dataInicio", formatISO(di, { representation: "date" }))
        change("dataFim", formatISO(df, { representation: "date" }))
    }

    const setDatasSemanaPassada = () => {
        let dateRef = new Date();
        dateRef.setDate(dateRef.getDate() - 7)
        const di = startOfWeek(dateRef, { weekStartsOn: 0 })

        const df = endOfWeek(dateRef, { weekStartsOn: 0 })

        change("dataInicio", formatISO(di, { representation: "date" }))
        change("dataFim", formatISO(df, { representation: "date" }))
    }

    const setDatasMesEste = () => {
        let dateRef = new Date();

        const di = startOfMonth(dateRef)

        const df = endOfMonth(dateRef)

        change("dataInicio", formatISO(di, { representation: "date" }))
        change("dataFim", formatISO(df, { representation: "date" }))
    }

    const setDatasMesPassado = () => {
        let dateRef = new Date();
        dateRef = new Date(dateRef.setMonth(dateRef.getMonth() - 1));
        const di = startOfMonth(dateRef)

        const df = endOfMonth(dateRef)

        change("dataInicio", formatISO(di, { representation: "date" }))
        change("dataFim", formatISO(df, { representation: "date" }))
    }

    const setDatasEsteAno = () => {
        let dateRef = new Date();

        const di = startOfYear(dateRef)

        const df = endOfYear(dateRef)

        change("dataInicio", formatISO(di, { representation: "date" }))
        change("dataFim", formatISO(df, { representation: "date" }))
    }

    const setDatasPassadoAno = () => {
        let dateRef = new Date();
        dateRef = new Date(dateRef.setFullYear(dateRef.getFullYear() - 1));
        const di = startOfYear(dateRef)

        const df = endOfYear(dateRef)

        change("dataInicio", formatISO(di, { representation: "date" }))
        change("dataFim", formatISO(df, { representation: "date" }))
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <DateInput name="dataInicio" label="Data de Início" required />
            <DateInput name="dataFim" label="Data de Fim" required />
            <DropDownButton color='primary'>
                <MenuItem onClick={setDatasEstaSemana}>Esta Semana</MenuItem>
                <MenuItem onClick={setDatasSemanaPassada}>Semana Passada</MenuItem>
                <MenuItem onClick={setDatasMesEste}>Este Mês</MenuItem>
                <MenuItem onClick={setDatasMesPassado}>Mês Passado</MenuItem>
                <MenuItem onClick={setDatasEsteAno}>Este Ano</MenuItem>
                <MenuItem onClick={setDatasPassadoAno}>Ano Passado</MenuItem>
            </DropDownButton>
        </div>
    )
}